import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import '~/styles/main.scss';
import { CopyBlock } from './index';
global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.CopyBlock = CopyBlock;
// CLR alias: PortableComponent.cshtml renders CopyBlockItem blocks via this component.
global.CopyBlockItem = CopyBlock;
